import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.scss";
import "./assets/css/responsive.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";

// AOS Animation Library
import AOS from "aos";
import "aos/dist/aos.css";

import Store from "./components/context/Store";
import AuthRouters from "./utils/AuthRouters";
import ErrorBoundary from "./components/general/ErrorBoundary";

function App() {
    useEffect(() => {
        // Initialize AOS animations
        AOS.init({
            duration: 800,
            easing: "ease-out-cubic",
            once: true,
            offset: 50,
            delay: 0,
        });

        // Defer analytics loading until browser is idle to avoid blocking initial render
        const loadAnalytics = () => {
            // Prevent duplicate initialization (React StrictMode runs useEffect twice)
            if (window._fbPixelInitialized) {
                return;
            }
            window._fbPixelInitialized = true;

            // Initialize fbq as a stub function BEFORE loading the script
            if (!window.fbq) {
                const fbq = function () {
                    fbq.callMethod
                        ? fbq.callMethod.apply(fbq, arguments)
                        : fbq.queue.push(arguments);
                };
                fbq.push = fbq;
                fbq.loaded = false;
                fbq.version = "2.0";
                fbq.queue = [];
                window.fbq = fbq;
                if (!window._fbq) window._fbq = fbq;

                window.fbq("init", "2311852975834940");
                window.fbq("track", "PageView");
            }

            // Load the Facebook Pixel script
            const fbPixelScript = document.createElement("script");
            fbPixelScript.async = true;
            fbPixelScript.src = "https://connect.facebook.net/en_US/fbevents.js";
            document.head.appendChild(fbPixelScript);

            fbPixelScript.onload = () => {
                window.fbq.loaded = true;
            };

            const fbNoScript = document.createElement("noscript");
            fbNoScript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=2311852975834940&ev=PageView&noscript=1" />
        `;
            document.body.appendChild(fbNoScript);

            // Load Google Analytics
            const gaScript = document.createElement("script");
            gaScript.async = true;
            gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-VYNC35SS62";
            document.head.appendChild(gaScript);

            const gaInitScript = document.createElement("script");
            gaInitScript.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-VYNC35SS62');
            `;
            document.head.appendChild(gaInitScript);
        };

        // Use requestIdleCallback to defer analytics until browser is idle
        if (typeof window.requestIdleCallback === "function") {
            window.requestIdleCallback(loadAnalytics);
        } else {
            setTimeout(loadAnalytics, 2000);
        }
    }, []);

    return (
        <ErrorBoundary>
            <Store>
                <AuthRouters />
            </Store>
        </ErrorBoundary>
    );
}

export default App;